function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { MESSAGE_TYPE_REDIRECT } from 'srcJs/components/realtime-notification/constants/constants';

var HandlerRedirect = /*#__PURE__*/function () {
  function HandlerRedirect(networkService) {
    _classCallCheck(this, HandlerRedirect);

    _defineProperty(this, "type", MESSAGE_TYPE_REDIRECT);

    this.networkService = networkService;
  }

  _createClass(HandlerRedirect, [{
    key: "execute",
    value: function execute(messageData) {
      var _this = this;

      var url = messageData.url,
          checkUrl = messageData.checkUrl;

      if (!checkUrl) {
        this.processToUrl(url);
        return;
      }

      this.networkService.get(checkUrl).then(function (response) {
        // @ts-ignore
        if (!response.data && response.status || response.data && response.data.status) {
          _this.processToUrl(url);
        }
      });
    }
  }, {
    key: "processToUrl",
    value: function processToUrl(url) {
      window.location.href = url;
    }
  }]);

  return HandlerRedirect;
}();

export { HandlerRedirect };